import ColourRow from './ColourRow';
import { ColourRowProps, ColourRowValueProps } from './types';

export type { ColourRowProps, ColourRowValueProps };
export default ColourRow;
